export default __webpack_public_path__ + "static/media/info.5aadb6e7.svg";